<ng-container *fbTemplate="let item of 'addressOptionTemplate'">
  <div class="first-line">{{ item.entity.description || (item.entity | address) }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'typeOptionTemplate'">
  <div class="first-line">{{ item.entity.label }}</div>
</ng-container>

<ng-container *fbTemplate="let item of 'DriverListOptionTemplate'">
  <div class="first-line">{{ item.entity.fullName }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'DriverAndTruckListOptionTemplate'">
  <div class="first-line">{{ item.entity.fullName }}</div>
  <div class="second-line">{{ item.entity.truck?.vehicleId || '-' }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'TruckListOptionTemplate'">
  <div class="first-line">{{ item.entity.vehicleId }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'TruckAndVinListOptionTemplate'">
  <div class="first-line">{{ item.entity.vehicleId }}</div>
  <div class="second-line">{{ item?.entity?.vin || '-' }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'PriceListOptionTemplate'">
  <div class="first-line">${{ item.entity.unit_amount / 100 }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'TimezoneOptionTemplate'">
  <div class="first-line">{{ item.entity.label }}</div>
</ng-container>
<ng-container *fbTemplate="let item of 'CompanyOptionTemplate'">
  <div
    class="first-line truncate"
    [matTooltip]="item.entity.name"
    [matTooltipDisabled]="item?.entity?.name?.length <= 19"
  >
    {{ item.entity.name }}
  </div>
</ng-container>
<ng-container *fbTemplate="let item of 'TenantOptionTemplate'">
  <div
    class="first-line truncate"
    [matTooltip]="item.entity.name"
    [matTooltipDisabled]="item?.entity?.name?.length <= 19"
  >
    {{ item.entity.name }}
  </div>
</ng-container>
